import React from 'react';
import { images } from '../utils/api';
import { useEscapeKey } from '../hooks/useEscapeKey';

function CoverImageSelectionModal({ coins, onSelect, onClose, currentCoverImage }) {
  useEscapeKey(onClose);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
      <div className="bg-white rounded-lg max-w-4xl w-full my-8 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 z-10 flex justify-between items-start px-6 py-4 border-b border-gray-200 bg-white shadow-sm">
          <h2 className="text-xl font-bold text-gray-900">Select Cover Image</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <span className="sr-only">Close</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {coins.map(coin => {
              if (!coin?.images?.length) return null;
              return coin.images.map((image, index) => (
                <button
                  key={`${coin.id}-${index}`}
                  onClick={() => onSelect(image.file_path)}
                  className={`relative aspect-square rounded-lg overflow-hidden border-2 ${
                    currentCoverImage && image.file_path && currentCoverImage.replace(/^\//, '') === image.file_path.replace(/^\//, '')
                      ? 'border-indigo-500' 
                      : 'border-transparent hover:border-gray-300'
                  }`}
                >
                  <img 
                    src={images.getImage(image.thumbnail_path || image.file_path, image.source)} 
                    alt={`${coin.year} ${coin.denomination} - Image ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-black bg-opacity-50 text-white text-xs p-1 text-center truncate">
                    {coin.year} {coin.denomination} ({index + 1}/{coin.images.length})
                  </div>
                  {currentCoverImage && image.file_path && currentCoverImage.replace(/^\//, '') === image.file_path.replace(/^\//, '') && (
                    <div className="absolute inset-0 bg-indigo-500 bg-opacity-20 flex items-center justify-center">
                      <span className="bg-indigo-500 text-white text-xs px-2 py-1 rounded">
                        Current Cover
                      </span>
                    </div>
                  )}
                </button>
              ));
            })}
          </div>
        </div>

        <div className="sticky bottom-0 flex justify-end px-6 py-4 border-t border-gray-200 bg-white">
          <button
            onClick={onClose}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default CoverImageSelectionModal;
